import templateCancel from './billingCancel.template.html';
import template from './billingSummary.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $mdDialog,
  $timeout,
  webpage,
  authenticationService,
  organizationService,
  eventService,
  billingService,
  dateTimeService,
  navigationService,
  changesService,
  uiService,
  OrganizationFeatures,
  Subscription,
  BILLING,
  INSTANCE
) => {
  $scope.Model = {
    availablePlans: [],
    oldPlan: null,
    currentPlan: {},
    upcomingInvoice: null,
    invoices: {},
    invoiceCharges: {},
    otherCharges: {},
    sk: INSTANCE.sk,
    invoicesList: null,
    isInvoiceReady: false,
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle(
    $rootScope.IsEnterprise
      ? 'Billing details : Settings'
      : 'Plan and billing details : Settings'
  );
  $scope.Model.isReady = false;

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadUpcomingInvoice = () =>
    billingService.upcoming().then((invoiceData) => {
      $scope.Model.upcomingInvoice = invoiceData;
    });

  const loadInvoices = () => {
    const deferred = $q.defer();
    billingService.invoices().then((invoices) => {
      $scope.Model.invoices = _.filter(invoices.data, (invoice) => invoice.charge !== null);
      deferred.resolve(invoices);
    });
    return deferred.promise;
  };

  const loadCharges = () => {
    const deferred = $q.defer();
    billingService.charges().then((charges) => {
      $scope.Model.invoiceCharges = _.filter(charges.data, (charge) => charge.invoice !== null);
      $scope.Model.otherCharges = _.filter(
        charges.data,
        (charge) =>
          charge.invoice === null &&
          charge.status === 'succeeded' &&
          charge.metadata.additionalCharge &&
          charge.metadata.additionalCharge === 'true' &&
          charge.refunded === false
      );
      deferred.resolve(charges);
    });
    return deferred.promise;
  };

  const saveChanges = () => {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      features: {
        configEDocSignatures: {
          automaticallyRecharge:
            $rootScope.CurrentOrganization.features.configEDocSignatures.automaticallyRecharge,
          rechargeWhenSignaturesRemainingReach:
            $rootScope.CurrentOrganization.features.configEDocSignatures
              .rechargeWhenSignaturesRemainingReach
        },
        configIdSmart: {
          automaticallyRecharge:
            $rootScope.CurrentOrganization.features.configIdSmart.automaticallyRecharge,
          rechargeWhenIdSmartRemainingReach:
            $rootScope.CurrentOrganization.features.configIdSmart
              .rechargeWhenIdSmartRemainingReach
        },
        configPpsr: {
          automaticallyRecharge:
            $rootScope.CurrentOrganization.features.configPpsr.automaticallyRecharge,
          rechargeWhenPpsrRemainingReach:
            $rootScope.CurrentOrganization.features.configPpsr.rechargeWhenPpsrRemainingReach
        },
        configSMS: {
          automaticallyRecharge:
            $rootScope.CurrentOrganization.features.configSMS.automaticallyRecharge,
          rechargeWhenSMSRemainingReach:
            $rootScope.CurrentOrganization.features.configSMS.rechargeWhenSMSRemainingReach
        }
      }
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (!result.status) {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  const initialize = () => {
    $q.all([
      organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
      billingService.getSeats(),
      billingService.getPlans()
    ]).then((data) => {
      const { subscription, features } = data[0];
      // eslint-disable-next-line no-param-reassign
      $rootScope.CurrentOrganization.subscription = subscription;
      // eslint-disable-next-line no-param-reassign
      $rootScope.CurrentOrganization.features = features;

      $scope.Model.billableUsers = data[1][0].accounts;
      $scope.Model.billableBrokers = data[1][0].brokers;
      $scope.Model.billablePartners = data[1][0].partners;
      $scope.Model.billablePhones = data[1][0].phones;
      $scope.Model.billableWebloanQ = data[1][0].webloanq;
      $scope.Model.availablePlans = data[2];
      $scope.Model.currentPlan = _.find($scope.Model.availablePlans, { id: 'SUBPROCESSOR' });
      if (!$rootScope.CurrentOrganization.isSubscribed()) {
        $scope.showSubscriptionInformation = true;
      } else {
        loadUpcomingInvoice();
        loadInvoices().then(() => {
          loadCharges().then(() => {
            if (
              ($scope.Model.invoiceCharges && $scope.Model.invoiceCharges.length) ||
              ($scope.Model.otherCharges && $scope.Model.otherCharges.length)
            ) {
              const lenI = $scope.Model.invoices.length;
              for (let i = 0; i < lenI; i += 1) {
                const lenC = $scope.Model.invoiceCharges.length;
                for (let j = 0; j < lenC; j += 1) {
                  if ($scope.Model.invoices[i].id === $scope.Model.invoiceCharges[j].invoice) {
                    $scope.Model.invoices[i].source = $scope.Model.invoiceCharges[j].source;
                  }
                }
              }
              const lenOC = $scope.Model.otherCharges.length;
              for (let k = 0; k < lenOC; k += 1) {
                $scope.Model.otherCharges[k].date = $scope.Model.otherCharges[k].created;
                $scope.Model.otherCharges[k].total = $scope.Model.otherCharges[k].amount;
                $scope.Model.otherCharges[k].tax_percent = parseInt(
                  $scope.Model.otherCharges[k].metadata.tax_percent || 0,
                  10
                );
                $scope.Model.otherCharges[k].subtotal = parseFloat(
                  $scope.Model.otherCharges[k].metadata.amount.replace('.', '') || 0,
                  10
                );
                // **************************************************************************
                // CHARGE FOR BASIQ APPEARS IN $ INSTEAD OF CENTS AND FUCKS UP MATHS IN INVOICE
                // **************************************************************************
                if ($scope.Model.otherCharges[k].subtotal < 100) {
                  $scope.Model.otherCharges[k].subtotal =
                    $scope.Model.otherCharges[k].subtotal * 100;
                }
                $scope.Model.otherCharges[k].amount = parseFloat(
                  $scope.Model.otherCharges[k].metadata.amount.replace('.', '') || 0,
                  10
                );
                // **************************************************************************
                // CHARGE FOR BASIQ APPEARS IN $ INSTEAD OF CENTS AND FUCKS UP MATHS IN INVOICE
                // **************************************************************************
                if ($scope.Model.otherCharges[k].amount < 100) {
                  $scope.Model.otherCharges[k].amount =
                    $scope.Model.otherCharges[k].amount * 100;
                }
                $scope.Model.otherCharges[k].quantity = parseInt(
                  $scope.Model.otherCharges[k].metadata.quantity || 0,
                  10
                );
              }
              $scope.Model.invoices = $scope.Model.invoices.concat($scope.Model.otherCharges);
              $scope.Model.isInvoicesReady = true;
            }
          });
        });
        $scope.showSubscriptionInformation = false;
        if (
          $rootScope.CurrentOrganization.getSubscriptionPlanId() === 'SUBCRM' ||
          $rootScope.CurrentOrganization.getSubscriptionPlanId() === 'SUBPROCESSOR'
        ) {
          $scope.Model.currentPlan = _.find($scope.Model.availablePlans, {
            id: $rootScope.CurrentOrganization.getSubscriptionPlanId()
          });
        } else {
          $scope.Model.oldPlan = _.find($scope.Model.availablePlans, {
            id: $rootScope.CurrentOrganization.getSubscriptionPlanId()
          });
        }
      }
      changesService.init({ useFinishOnInterval: true });
      changesService.onFinish(saveChanges);
      $scope.Model.isReady = true;
    });
  };

  initialize();

  $scope.toggleChanges = (group, field) => {
    changesService.change({ group, field });
  };

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('subscriptionChangePlan', ($event) => {
    $event.preventDefault();
    $scope.showSubscriptionInformation = !$scope.showSubscriptionInformation;
  });

  $scope.$on('subscriptionChangePayment', ($event) => {
    $event.preventDefault();
    if ($rootScope.CurrentOrganization.isSubscribed()) {
      $timeout(() => {
        angular.element('#payment').triggerHandler('click');
      });
    }
  });

  $scope.$on('subscriptionCancel', ($event) => {
    $event.preventDefault();
    $mdDialog
      .show({
        targetEvent: $event,
        template: templateCancel,
        controllerAs: '$ctrl',
        controller() {
          const ctrl = this;
          ctrl.CurrentOrganization = $rootScope.IsEnterprise;
          ctrl.INSTANCE = INSTANCE;
          ctrl.confirm = () => {
            $mdDialog.hide();
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then(() => {
        $scope.unsubscribe();
      });
  });

  /*
   * Helper Methods
   * --------------------------------------------------------------------------------
   */
  $scope.billingEnterprise = ($event, planName) => {
    $scope.toggleActivePlan(planName);
    $event.stopPropagation();
    if (!$rootScope.CurrentOrganization.isSubscribed()) {
      if (planName === 'CRM Subscription') {
        $timeout(() => {
          angular.element('#subcrm').triggerHandler('click');
        });
      } else {
        $timeout(() => {
          angular.element('#subprocessor').triggerHandler('click');
        });
      }
    }
  };
  $scope.billingSummary = ($event, planName) => {
    $scope.toggleActivePlan(planName);
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          currentPlan: $scope.Model.currentPlan,
          brokerPlan: BILLING.PLAN_BROKERS,
          partnerPlan: BILLING.PLAN_PARTNERS,
          phonePlan: BILLING.PLAN_PHONES,
          webloanqPlan: BILLING.PLAN_WEBLOANQ,
          billingTax: BILLING.BILLING_DETAILS.TAX,
          billableUsers: $scope.Model.billableUsers,
          billableBrokers: $scope.Model.billableBrokers,
          billablePartners: $scope.Model.billablePartners,
          billablePhones: $scope.Model.billablePhones
        },
        template,
        controllerAs: '$ctrl',
        controller(
          currentPlan,
          brokerPlan,
          partnerPlan,
          phonePlan,
          webloanqPlan,
          billingTax,
          billableUsers,
          billableBrokers,
          billablePartners,
          billablePhones
        ) {
          const ctrl = this;
          ctrl.CurrentOrganization = $rootScope.CurrentOrganization;
          ctrl.currentPlan = currentPlan;
          ctrl.brokerPlan = brokerPlan;
          ctrl.partnerPlan = partnerPlan;
          ctrl.phonePlan = phonePlan;
          ctrl.webloanqPlan = webloanqPlan;
          ctrl.billingTax = billingTax;
          ctrl.billableUsers = billableUsers;
          ctrl.billableBrokers = billableBrokers;
          ctrl.billablePartners = billablePartners;
          ctrl.billablePhones = billablePhones;
          ctrl.billableWebloanQ = 1;

          ctrl.getTotalMainSubscription = ctrl.currentPlan.getTotalWithTaxWithoutFormated(
            ctrl.billableUsers
          );
          ctrl.getTotalMainSubscriptionString = ctrl.currentPlan.getTotalWithTax(
            ctrl.billableUsers
          );

          ctrl.getTotalBrokerSubscription = () =>
            ctrl.brokerPlan.value * ctrl.billableBrokers * ((100 + ctrl.billingTax) / 100);
          ctrl.getTotalBrokerSubscriptionString = () =>
            ctrl.getTotalBrokerSubscription().formatWithCurrency('$', 2);

          ctrl.getTotalPartnerSubscription = () =>
            ctrl.partnerPlan.value * ctrl.billablePartners * ((100 + ctrl.billingTax) / 100);
          ctrl.getTotalPartnerSubscriptionString = () =>
            ctrl.getTotalPartnerSubscription().formatWithCurrency('$', 2);

          ctrl.getTotalPhoneSubscription = () =>
            ctrl.phonePlan.value * ctrl.billablePhones * ((100 + ctrl.billingTax) / 100);
          ctrl.getTotalPhoneSubscriptionString = () =>
            ctrl.getTotalPhoneSubscription().formatWithCurrency('$', 2);

          ctrl.getTotalWebloanQSubscription = () =>
            ctrl.webloanqPlan.value * ctrl.billableWebloanQ * ((100 + ctrl.billingTax) / 100);
          ctrl.getTotalWebloanQSubscriptionString = () =>
            ctrl.getTotalWebloanQSubscription().formatWithCurrency('$', 2);

          ctrl.getTotal = (
            ctrl.getTotalMainSubscription +
            (ctrl.currentPlan.id === 'SUBPROCESSOR' ? ctrl.getTotalBrokerSubscription() : 0) +
            ctrl.getTotalPartnerSubscription() +
            ctrl.getTotalPhoneSubscription()
          ).formatWithCurrency('$', 2);

          ctrl.confirm = () => {
            $mdDialog.hide(ctrl.currentPlan.getName());
          };
          ctrl.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((result) => {
        if (!$rootScope.CurrentOrganization.isSubscribed()) {
          if (result === 'CRM Subscription') {
            $timeout(() => {
              angular.element('#subcrm').triggerHandler('click');
            });
          } else {
            $timeout(() => {
              angular.element('#subprocessor').triggerHandler('click');
            });
          }
        } else {
          $scope.change();
        }
      });
  };

  $scope.listReady = (list) => {
    $scope.Model.invoicesList = list;
  };

  $scope.toggleActivePlan = (planName) => {
    $scope.Model.currentPlan = _.find($scope.Model.availablePlans, {
      id: $scope.getPlanId(planName || $scope.Model.currentPlan.name, false)
    });
  };

  $scope.subscribe = (token) => {
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.subscribe({ idPlan: $scope.Model.currentPlan.id, token }).then((payload) => {
      if (!payload.status) {
        initialize();
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'subscription',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
        eventService.credentialsChanged();
      }
    });
  };

  $scope.changePayment = (token) => {
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.update({ token }).then(() => {
      navigationService.organizationChange({
        idOrganization: $rootScope.CurrentOrganization.id
      });
      initialize();
    });
  };

  $scope.unsubscribe = () => {
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.unsubscribe().then(() => {
      navigationService.organizationChange({
        idOrganization: $rootScope.CurrentOrganization.id
      });
      initialize();
    });
  };

  $scope.change = () => {
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.change({ idPlan: $scope.Model.currentPlan.id }).then(() => {
      navigationService.organizationChange({
        idOrganization: $rootScope.CurrentOrganization.id
      });
      initialize();
    });
  };
  $scope.confirm = async (ev, purchaseItem) => {
    const confirm = $mdDialog
      .confirm()
      .title('Attention')
      .textContent(`Please confirm ${purchaseItem}.`)
      .ariaLabel('Confirm')
      .targetEvent(ev)
      .ok('Confirm')
      .cancel('Cancel');

    try {
      await $mdDialog.show(confirm);
      return true;
    } catch (e) {
      return false;
    }
  };

  $scope.purchaseSignatures = async ($event) => {
    if (!(await $scope.confirm($event, 'purchase of 100 Annature Signatures'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseSignatures().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchaseSMS = async ($event) => {
    if (!(await $scope.confirm($event, 'purchase of 1000 SMS'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseSMS().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchaseWebloanQ = async ($event) => {
    if (!(await $scope.confirm($event, 'monthly subscription to WebloanQ'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseWebloanQ().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchaseWebloanQUnsubscribe = async ($event) => {
    if (!(await $scope.confirm($event, 'unsubscription from WebloanQ'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseWebloanQUnsubscribe().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchaseIdSmart = async ($event) => {
    if (!(await $scope.confirm($event, 'purchase of 20 IDSmart'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseIdSmart().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchaseBasiq = async ($event) => {
    if (!(await $scope.confirm($event, 'purchase of 10 Basiq'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchaseBasiq().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.purchasePpsr = async ($event) => {
    if (!(await $scope.confirm($event, 'purchase of 20 PPSR'))) {
      return;
    }
    $scope.Model.isReady = false;
    $scope.Model.isInvoiceReady = false;
    billingService.purchasePpsr().then((payload) => {
      if (!payload.status) {
        $scope.Model.isReady = true;
        $scope.Model.isInvoiceReady = true;
        uiService.toast({
          text: {
            p1: 'Your',
            p2: 'purchase',
            p3: 'failed'
          },
          warn: true
        });
      } else {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        initialize();
      }
    });
  };

  $scope.getPlan = (name) =>
    _.find($scope.Model.availablePlans, { id: $scope.getPlanId(name) });

  $scope.getPlanId = (name) => (name === 'Processor Subscription' ? 'SUBPROCESSOR' : 'SUBCRM');

  $scope.isOwner = () => authenticationService.isOwner();

  $scope.isPlanChange = (planName) =>
    $scope.Model.currentPlan.name === planName
      ? $rootScope.CurrentOrganization.getSubscriptionPlanId() !== $scope.Model.currentPlan.id
      : true;

  $scope.getTotal = (invoiceTotal) =>
    (invoiceTotal / 100).formatWithCurrency({ symbol: '$' }, 2);

  $scope.getDate = (invoiceDate) => dateTimeService.getFormattedDate(invoiceDate);

  $scope.printInvoice = ($event, invoice) => {
    let output = '';

    if (invoice.lines) {
      const len = invoice.lines.data.length;
      for (let i = 0; i < len; i += 1) {
        output += `<tr class="item"><td>${invoice.lines.data[i].plan.name}</td>
            <td>${invoice.lines.data[i].quantity} billable users</td>
            <td>${
              invoice.lines.data[i].description !== null
                ? invoice.lines.data[i].description
                : '-'
            }</td>
            <td>${$scope.getTotal(invoice.lines.data[i].amount)}</td>
            </tr>`;
      }
    } else {
      output = `<tr class="item"><td>${invoice.description}</td>
          <td>${invoice.quantity}</td>
          <td></td>
          <td>${$scope.getTotal(invoice.amount)}</td>
          </tr>`;
    }

    const popupWin = window.open('', '_blank', '');
    popupWin.document.open();
    popupWin.document.write(
      `<!doctype html>
          <html>
          <head>
          <meta charset="utf-8">
          <title>Salestrekker Invoice ID ${invoice.id}</title>
          <link rel="icon" href="https://www.salestrekker.com/images/favicon-16x16.png" type="image/png" sizes="16x16">
          <style>
          .invoice-box {
          height: 100vh;
          max-width: 800px;
          margin: auto;
          padding: 50px 30px 30px 30px;
          border: 1px solid #eee;
          box-shadow: 0 0 15px rgba(0, 0, 0, .1);
          font-size: 16px;
          line-height: 24px;
          font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
          color: #555;
          position: relative;
          }
          .invoice-box h1 {
          color: #2196f3;
          font-weight: 300;
          }
          .invoice-box table {
          width: 100%;
          line-height: inherit;
          text-align: left;
          }
          .invoice-box table td {
          padding: 5px;
          vertical-align: top;
          }
          .invoice-box table tr td:nth-child(4), td.right {
          text-align: right;
          }
          .invoice-box table tr.top table td {
          padding-bottom: 20px;
          }
          .invoice-box table tr.top table td.title {
          font-size: 45px;
          line-height: 45px;
          color: #333;
          }
          .invoice-box table tr.information table td {
          padding-bottom: 40px;
          }
          .invoice-box table tr.title td {
          font-size: 18px;
          text-transform: uppercase;
          }
          .invoice-box table tr.heading td {
          background: #eee;
          border-bottom: 1px solid #ddd;
          font-weight: bold;
          }
          .invoice-box table tr.details td {
          padding-bottom: 20px;
          }
          .invoice-box table tr.item td {
          border-bottom: 1px solid #eee;
          }
          .invoice-box table tr.item.last td {
          border-bottom: none;
          }
          .invoice-box table tr.total td:nth-child(4), td.right {
          font-weight: bold;
          }
          .invoice-box table tr.total td:nth-child(4) {
          border-top: 2px solid #eee;
          }
          .invoice-box table tr.total td:nth-child(4).subtotal {
          border-top: 1px solid #eee;
          }
          .print {
          background: #eee;
          border-radius: 5px;
          cursor: pointer;
          position: absolute;
          top: 15px;
          right: 43px;
          padding: 5px 10px;
          }
          .print:hover {
          background: #e5e5e5;
          }
          .print span {
          font-size: 11px;
          padding-left: 30px;
          text-transform: uppercase;
          }
          .print-solid.icon {
          color: #555;
          position: absolute;
          margin-left: 2px;
          margin-top: 5px;
          width: 15px;
          height: 6px;
          border-radius: 1px 1px 0 0;
          border: solid 1px #555;
          background-color: #555;
          top: 8px;
          }
          .print-solid.icon:before {
          content: "";
          position: absolute;
          left: 2px;
          top: -3px;
          height: 13px;
          width: 9px;
          border: solid 1px #555;
          background-color: white;
          }
          .print-solid.icon:after {
          content: "";
          position: absolute;
          left: 1px;
          top: -1px;
          width: 13px;
          height: 3px;
          border-top: solid 1px #555;
          border-bottom: solid 1px #555;
          background-color: #555;
          }
          @media only screen and (max-width: 600px) {
          .invoice-box table tr.top table td {
          width: 100%;
          display: block;
          text-align: center;
          }
          .invoice-box table tr.information table td {
          width: 100%;
          display: block;
          text-align: center;
          }
          }
          @media print {
          .invoice-box {
          height: 100%;
          border: 0;
          box-shadow: none;
          padding: 30px;
          }
          .print {
          display: none;
          }
          }
          </style>
          <script>
          function printInvoice() { window.print(); }
          </script>
          </head>
          <body>
          <div class="invoice-box">
          <div class="print" onclick="printInvoice()">
          <div class="print-solid icon"></div>
          <span>Print Invoice</span>
          </div>
          <table>
          <tr class="top">
          <td colspan="4">
          <table>
          <tr>
          <td>
            <img src="https://www.salestrekker.com/images/logo@2x.png" alt="Salestrekker" style="width:100%; max-width:300px;">
          </td>
          <td></td>
          <td></td>
          <td>
            <h1 style="margin-top: 55px">INVOICE</h1>
          </td>
          </tr>
          <tr>
          <td>
            ABN: 19 659 282 827<br>
            Phone: +61 02 9037 7350<br>
            Address: Level 23, 520 Oxford Street<br>
            Bondi Junction NSW 2022, Australia<br>
          </td>
          <td></td>
          <td></td>
          <td style="text-align: left;">
            Date: ${$scope.getDate(invoice.date)}<br>
            Invoice: ${invoice.id}<br>
            Attn: ${invoice.source.name}<br>
            ${$rootScope.CurrentOrganization.getName()}<br>
          </td>
          </tr>
          </table>
          </td>
          </tr>
          <tr class="information">
          <td colspan="4">
          </td>
          </tr>

          <tr class="title">
          <td colspan="4">Payment Summary</td>
          </tr>
          <tr class="heading">
          <td>Method</td>
          <td>Brand</td>
          <td>${invoice.source.object.capitalizeFirstLetter()}</td>
          <td>Amount</td>
          </tr>
          <tr class="details">
          <td>${invoice.source.object.capitalizeFirstLetter()}</td>
          <td>${invoice.source.brand}</td>
          <td>**** **** **** ${invoice.source.last4}</td>
          <td>${$scope.getTotal(invoice.total)}</td>
          </tr>

          <tr class="title">
          <td colspan="4">Transaction Summary</td>
          </tr>
          <tr class="heading">
          <td>${invoice.lines ? 'Item' : 'Description'}</td>
          <td>Quantity</td>
          <td>${invoice.lines ? 'Description' : ''}</td>
          <td>Amount</td>
          </tr>${output}<tr class="total">
          <td></td>
          <td></td>
          <td class="right">Subtotal:</td>
          <td class="subtotal">${$scope.getTotal(invoice.subtotal)}</td>
          </tr>
          <tr class="total">
          <td></td>
          <td></td>
          <td class="right">GST:</td>
          <td>${$scope.getTotal(invoice.total - invoice.subtotal)}</td>
          </tr>
          <tr class="total">
          <td></td>
          <td></td>
          <td class="right">Total including GST:</td>
          <td>${$scope.getTotal(invoice.total)}</td>
          </tr>

          </table>
          </div>
          </body>
          </html>`
    );
    popupWin.document.close();
  };
};
